import { render, staticRenderFns } from "./send-survey.vue?vue&type=template&id=05dcc362&scoped=true&"
import script from "./send-survey.vue?vue&type=script&lang=js&"
export * from "./send-survey.vue?vue&type=script&lang=js&"
import style0 from "./send-survey.vue?vue&type=style&index=0&id=05dcc362&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05dcc362",
  null
  
)

export default component.exports